/**
 * Return id from url. Returns 0 if one can't be found.
 *
 * @example getIdFromUrl()
 * @returns number
 */

export function getIdFromUrl(): number {
	const pathArray = window.location.pathname.split('/')

	return parseInt(pathArray[2]) || 0
}
